import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetCanbotEvaluationClass, IGetDailyMissionDetail, IGetDailyMissionSummaryClass } from '../models/canbot.model';

const uri = '/mgmt/canbot';

export const getCanbotEvaluationClass = (classCode: string): AxiosPromise<IGetCanbotEvaluationClass> => {
  return axios.get(`${uri}/evaluation/class/${classCode}`);
};

export const getDailyMissionSummaryClass = (classCode: string, weekSeq: number): AxiosPromise<IGetDailyMissionSummaryClass> => {
  return axios.get(`${uri}/dailymission/summary/${classCode}/${weekSeq}`);
};

export const getDailyMissionDetail = (studyCode: number, weekSeq: number): AxiosPromise<IGetDailyMissionDetail> => {
  return axios.get(`${uri}/dailymission/detail/${studyCode}/${weekSeq}`);
};